<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  isOpen?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});
</script>

<template>
  <KBtn
    :class="$style.tableFoldBtn"
    data-testid="tableFoldBtn"
    variant="text"
    :icon="props.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'"
    rounded="50"
    priority="text"
    size="xs"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tableFoldBtn {
  :global {
    .v-icon {
    }
  }
}
</style>
